const timeConstant = {
    MINUTE: 60,
    HOUR: 60 * 60,
    DAY: 24 * 60 * 60,
    WEEK: 7 * 24 * 60 * 60,
}

const queryConstant = {}

// sequence matters !!!
const commonTranslationNamespaces = ['headerFooter', 'common']

export { commonTranslationNamespaces, timeConstant, queryConstant }
